var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.3483 6.58442L8.23988 4.69283V12.1262C8.23988 12.4024 8.46374 12.6262 8.73988 12.6262H9.23988C9.51602 12.6262 9.73988 12.4024 9.73988 12.1262V4.6727L11.6516 6.58442C11.8469 6.77968 12.1634 6.77968 12.3587 6.58442L12.7123 6.23087C12.9075 6.0356 12.9075 5.71902 12.7123 5.52376L9.3535 2.165C9.15824 1.96974 8.84166 1.96974 8.64639 2.165L5.28764 5.52376C5.09237 5.71902 5.09237 6.0356 5.28764 6.23087L5.64119 6.58442C5.83645 6.77968 6.15303 6.77968 6.3483 6.58442ZM2.20801 13.3332L2.20801 14.7429C2.20801 15.4333 2.76765 15.9929 3.45801 15.9929H14.5419C15.2323 15.9929 15.7919 15.4333 15.7919 14.7429V13.3332C15.7919 13.0571 15.5681 12.8332 15.2919 12.8332H14.7919C14.5158 12.8332 14.2919 13.0571 14.2919 13.3332V14.4929H3.70801V13.3332C3.70801 13.0571 3.48415 12.8332 3.20801 12.8332H2.70801C2.43187 12.8332 2.20801 13.0571 2.20801 13.3332Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.da4d56fd12e714335401b52686e6d9d1.svg";
export { ForwardRef as ReactComponent };